import type { ComponentProps } from 'react';

const HomeExclamation = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_1111_41078)">
        <path
          d="M7.76317 0.480469C7.99754 0.282552 8.33869 0.282552 8.57306 0.480469L14.3673 5.39974C14.1121 5.35547 13.8491 5.33203 13.5835 5.33203C13.2137 5.33203 12.8517 5.3763 12.508 5.45964L8.16681 1.77734L3.58348 5.66536V11.582C3.58348 12.043 3.95587 12.4154 4.41681 12.4154H9.74233C10.0626 12.9049 10.4715 13.3294 10.9481 13.6654H4.41681C3.26577 13.6654 2.33348 12.7331 2.33348 11.582V6.72526L1.69546 7.26693C1.43244 7.49089 1.0366 7.45703 0.815248 7.19401C0.593894 6.93099 0.625144 6.53516 0.888165 6.3138L7.76317 0.480469ZM9.00014 6.9987H10.047C9.64858 7.48047 9.3465 8.04557 9.17202 8.66537H9.00014V9.91537C9.00014 10.1445 8.81264 10.332 8.58348 10.332H7.75014C7.52098 10.332 7.33348 10.1445 7.33348 9.91537V8.66537H6.08348C5.85431 8.66537 5.66681 8.47787 5.66681 8.2487V7.41536C5.66681 7.1862 5.85431 6.9987 6.08348 6.9987H7.33348V5.7487C7.33348 5.51953 7.52098 5.33203 7.75014 5.33203H8.58348C8.81264 5.33203 9.00014 5.51953 9.00014 5.7487V6.9987ZM13.5835 6.16536C14.578 6.16536 15.5319 6.56045 16.2351 7.26371C16.9384 7.96698 17.3335 8.9208 17.3335 9.91537C17.3335 10.9099 16.9384 11.8638 16.2351 12.567C15.5319 13.2703 14.578 13.6654 13.5835 13.6654C12.5889 13.6654 11.6351 13.2703 10.9318 12.567C10.2286 11.8638 9.83348 10.9099 9.83348 9.91537C9.83348 8.9208 10.2286 7.96698 10.9318 7.26371C11.6351 6.56045 12.5889 6.16536 13.5835 6.16536ZM13.5835 12.4154C13.7492 12.4154 13.9082 12.3495 14.0254 12.2323C14.1426 12.1151 14.2085 11.9561 14.2085 11.7904C14.2085 11.6246 14.1426 11.4656 14.0254 11.3484C13.9082 11.2312 13.7492 11.1654 13.5835 11.1654C13.4177 11.1654 13.2587 11.2312 13.1415 11.3484C13.0243 11.4656 12.9585 11.6246 12.9585 11.7904C12.9585 11.9561 13.0243 12.1151 13.1415 12.2323C13.2587 12.3495 13.4177 12.4154 13.5835 12.4154ZM13.5835 7.41536C13.3543 7.41536 13.1668 7.60286 13.1668 7.83203V9.91537C13.1668 10.1445 13.3543 10.332 13.5835 10.332C13.8126 10.332 14.0001 10.1445 14.0001 9.91537V7.83203C14.0001 7.60286 13.8126 7.41536 13.5835 7.41536Z"
          fill="#63707F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1111_41078">
          <rect
            width="16.6667"
            height="13.3333"
            fill="white"
            transform="translate(0.666016 0.332031)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomeExclamation;
